import { captureException } from '@sentry/browser';

/**
 * Use this method to capture exceptions due to play() failing for an <audio> element.
 * @param e The thrown exception, as caught in the catch statement.
 * @param audio The HTMLAudioElement which was attempted to play().
 * @param localSessionId The sessionId as returned from useLocalSessionId().
 * @param extra Optional additional extra data to be captured in Sentry. Should contain context information, e.g. which component caught this exception.
 */
export const captureAudioPlayException = (
  e: any,
  audio: HTMLAudioElement,
  localSessionId: string,
  extra: Record<string, unknown> = {}
) => {
  const audioTrack = (audio.srcObject as MediaStream)?.getAudioTracks()?.[0];
  captureException(e, {
    extra: {
      audioElement: audio.outerHTML,
      dataset: { ...audio.dataset },
      localSessionId: localSessionId,
      mediaStreamTrack: {
        // contentHint not available in Next.js types?
        // @ts-ignore
        contentHint: audioTrack?.contentHint,
        enabled: audioTrack?.enabled,
        id: audioTrack?.id,
        kind: audioTrack?.kind,
        label: audioTrack?.label,
        muted: audioTrack?.muted,
        readyState: audioTrack?.readyState,
      },
      ...extra,
    },
  });
};
